import requester from 'core/http/requester';
import { CONTENT_TYPES } from 'constants/common';
import {
  COMMENT_SENDING_FAILED,
  STATUS_OK,
  REVIEW_USER_EMAIL,
  REVIEW_USER_NAME
} from 'constants/review';

class Review {
  reviewApiUrl: any;
  courseId: any;
  name: any;
  email: any;
  authoringToolDomain: any;

  initialize({ reviewApiUrl, courseId, authoringToolDomain }: any) {
    this.reviewApiUrl = reviewApiUrl;
    this.courseId = courseId;
    this.authoringToolDomain = authoringToolDomain;
    this.restoreUser();
  }

  async sendCommentRequest({ data }: any) {
    let online = window.navigator.onLine;
    if (!online) {
      return COMMENT_SENDING_FAILED;
    }
    data.createdByName = this.name;
    data.createdBy = this.email;
    data.courseId = this.courseId;
    let response = await requester.post(`${this.reviewApiUrl}comments`, {
      headers: {
        'Content-Type': CONTENT_TYPES.JSON,
        'X-Authoring-Tool-Domain': this.authoringToolDomain
      },
      data
    });

    if (response.status !== 200) {
      return COMMENT_SENDING_FAILED;
    }

    return STATUS_OK;
  }

  restoreUser() {
    this.email = localStorage.getItem(REVIEW_USER_EMAIL);
    this.name = localStorage.getItem(REVIEW_USER_NAME);

    return {
      name: this.name,
      email: this.email
    };
  }

  storeUser(data: any) {
    localStorage.setItem(REVIEW_USER_EMAIL, data.email);
    localStorage.setItem(REVIEW_USER_NAME, data.name);
    this.email = data.email;
    this.name = data.name;
  }
}

export default new Review();
